import {
  ADD_ITEM,
  REMOVE_ITEMS,
  SELECT_ITEMS,
  UPDATE_ITEMS,
  REMOVE_ALL_ITEMS,
  MOVE_ITEM,
  SAVE_ALL_ITEMS,
  SET_ITEMS,

} from '../actions/actionTypes'

function pickSelectedItems (items) {
  let selectedItems = []
  items.forEach(item => {
    if (item.selected) {
      selectedItems.push(item)
    }
  })
  return selectedItems
}

function pickCommentedItems(items) {
  let commentedItems = items.filter(it => {
    const annoComment = _.get(it, "data.annoComment", null);
    return !_.isNil(annoComment);
  });

  commentedItems.sort(
    (a, b) => a.data.annoComment.updateTime < b.data.annoComment.updateTime
  );

  return commentedItems;
}

export const paintItems = (
  state = {
    items: [],
    selectedItems: [],
    commentedItems: [],
    updateTime: Date.now()
  },
  action
) => {
  let newState = null
  switch (action.type) {
    case ADD_ITEM:
      newState = {
        ...state,
        items: [...state.items, action.payload]
      }
      newState.updateTime = Date.now()
      break
    case SET_ITEMS:
      // remove all previous items
      state.items.forEach(it => it.remove())
      newState = {
        items: action.payload.items,
        updateTime: action.payload.updateTime || Date.now(),
      }
      break;
    case UPDATE_ITEMS:
      const updateItems = _.get(action, 'payload.items', null)
      newState = updateItems
        ? {
          items: updateItems
        }
        : {
          ...state
        }
      newState.updateTime = _.get(action, 'payload.updateTime', Date.now())
      break
    case REMOVE_ITEMS:
      const ritems = action.payload
      ritems.forEach(t => t.remove())
      const ritemIds = action.payload.map(t => t.id)
      newState = {
        items: state.items.filter(t => !ritemIds.includes(t.id))
      }
      newState.updateTime = Date.now()
      break
    case REMOVE_ALL_ITEMS:
      state.items.forEach(t => t.remove())
      newState = {
        items: []
      }
      newState.updateTime = Date.now()
      break
    case SELECT_ITEMS:
      newState = {
        ...state
      }
      let sids = action.payload.map(i => i.id)
      newState.items.forEach(item => {
        item.selected = sids.includes(item.id)
      })
      newState.updateTime = Date.now()
      break
    case MOVE_ITEM:
      const { item, toIndex } = action.payload
      console.log(item, toIndex)
      const newItems = state.items.filter(it => it.id !== item.id)
      newItems.splice(toIndex, 0, item)
      newState = {
        items: newItems
      }
      newState.updateTime = Date.now()
      break
    case SAVE_ALL_ITEMS:
      // newState = { savedTaskItemId: action.payload.savedTaskItemId }
      newState= Object.assign({savedTaskItemId: action.payload.savedTaskItemId}, state)
      newState.updateTime = Date.now()
      break
    default:
      return state
  }
  newState.selectedItems = pickSelectedItems(newState.items)
  newState.commentedItems = pickCommentedItems(newState.items)
  return newState
}



// WEBPACK FOOTER //
// ./src/redux/reducers/paintItems.js